import { clamp } from "lodash-es";
import {
	type GoalPortfolioResponseDTO,
	GoalPortfolioTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { joinTruthy } from "web_myplann/Shared/Utils/textFormatters";

export const useGoalDetailSolutionItem = (
	portfolio: GoalPortfolioResponseDTO,
	dueYear?: number,
) => {
	const { t } = useResource();

	const isSetAside = portfolio.type === GoalPortfolioTypeEnum.SetAside;

	const title = portfolio.domain
		? t(Resources.Portfolio.List.PortfolioDomainType[portfolio.domain])
		: "";
	const subtitle = joinTruthy([portfolio.producer, portfolio.product]);

	const allocationPercent = clamp(portfolio.usagePercent ?? 0, 0, 100);
	const showAllocation = !isSetAside && allocationPercent < 100;

	const displayValue = isSetAside
		? (portfolio.portfolioValue ?? 0)
		: (portfolio.usageValue ?? 0);

	const expectedCoverage = portfolio.expectedCoverage ?? 0;
	const showProjection =
		!isSetAside && expectedCoverage > 0 && dueYear !== undefined;

	return {
		title,
		subtitle,
		allocationPercent,
		showAllocation,
		displayValue,
		expectedCoverage,
		showProjection,
	};
};
